export default "__VITE_ASSET__C8MYfsSC__"